﻿import { BEFORE_SUBMIT_EVENT_NAME, clearValidationMessage, getSubmitterFromEvent } from './changePersonalData';

export const initChangePersonalDataStpSummary = () => {
    // Reason codes whose selection makes the date field mandatory.
    // These mirror the server-side check in ValidateChangePersonalDataStpSummary.
    //  2 = TemporaryAddressUntilCollateralReady
    //  3 = MortgageIsRedeemed
    //  4 = Rental
    //  5 = RentalStayForeignCountry
    //  7 = CollateralForSaleAndRented
    const REASONS_REQUIRING_DATE = new Set(['2', '3', '4', '5', '7']);
    const FORM_ROLE = 'change-personal-data-stp-form';
    const BOUND_FLAG = 'changePersonalDataStpSummaryBound';

    const form = document.querySelector(`[data-role="${FORM_ROLE}"]`);
    if (!form) return;

    if (form.dataset[BOUND_FLAG] === 'true') return;
    form.dataset[BOUND_FLAG] = 'true';

    const reasonSelect = form.querySelector('[data-role="reason-for-address-change"]');
    const dateWrapper = form.querySelector('[data-role="date-for-address-change"]');
    const dateInput = dateWrapper?.querySelector('input, textarea, select') ?? null;

    // Add loading state to the submit button. Validation and submitting-state
    // management is owned by Form.js via the sds:form:beforeSubmit lifecycle.
    const handleBeforeSubmitLoadingState = (event) => {
        if (event.defaultPrevented) return;

        const submitter = getSubmitterFromEvent(event);
        if (submitter) {
            submitter.classList.add('loading');
        }
    };

    form.addEventListener(BEFORE_SUBMIT_EVENT_NAME, handleBeforeSubmitLoadingState);

    if (!reasonSelect) return;

    const apply = () => {
        const showDate = REASONS_REQUIRING_DATE.has(reasonSelect.value);

        if (dateWrapper) {
            dateWrapper.hidden = !showDate;
        }

        // Clear the date value and any stale validation state when hidden so the
        // next required selection starts from a clean slate.
        if (!showDate && dateInput) {
            dateInput.value = '';
            clearValidationMessage(form, dateInput);
        }
    };

    // Remark required-if logic is handled entirely by [RequiredIf] on the model,
    // which emits data-val-requiredif-* attributes consumed by requiredifvalidator.js.
    // No JS rule manipulation is needed here.

    reasonSelect.addEventListener('change', apply);
    apply();
};